import { useContext } from 'react';
import { TranslationContext, TranslationContextState } from './const';

export function useTranslationState() {
	const context = useContext(TranslationContextState);
	if (context === undefined) {
		throw new Error('useTranslationState must be used within a TranslationProvider');
	}

	return context;
}

export function useTranslationAPI() {
	const context = useContext(TranslationContext);
	if (context === undefined) {
		throw new Error('useTranslationAPI must be used within a TranslationContextAPIProvider');
	}

	return context;
}
